// Resolves the operator-visible "Customer" name for a field job, applying
// the commercial-vs-residential inference rule documented in the FieldHub
// calendar redesign spec (docs/fieldhub-calendar-redesign-plan.md).
//
// Rule (in priority order):
//   1. job.company_name (denormalized snapshot via contactSnapshot at
//      insert time) — set when the picked contact had a company
//      affiliation. → commercial-shape job: show the company.
//   2. job.location.company.name — locations.company_id is NOT NULL by
//      schema, so a job with a location is implicitly commercial. Covers
//      older rows or imports that lack the denormalized snapshot.
//   3. job.contact_name (NOT NULL on field_jobs) — residential: show the
//      person.
//
// Pure function. Always returns a non-empty string. Unit-testable + reusable
// beyond the calendar.

export interface CustomerLabelJob {
  company_name?: string | null
  contact_name: string
  location?: { company?: { name: string } | null } | null
}

export function customerLabelForJob(job: CustomerLabelJob): string {
  const snap = job.company_name?.trim()
  if (snap) return snap
  const locCo = job.location?.company?.name?.trim()
  if (locCo) return locCo
  return job.contact_name
}
